import React, { Component } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import DadosEntidade from './sealPopUp/DadosEntidade'
import History from './sealPopUp/History'
import services from '../../../services'
import RequestDetails from './sealPopUp/RequestDetails'
import { toast } from 'react-toastify'


class SidePopup extends Component {
    constructor(props){
        super(props)
        this.state = {
            tab : 'detalhes',
            entityDetail: {
                telephone: '',
                email: '',
                fax: ''
            },
            menu: props.header.menu,
            submenu: props.header.submenu,
            data:'',
            sealsRes:[],
            estatutosRes:[],
            returnSeries: []
        }
    }
    componentDidMount = () => {
        console.log("9990 mount ")
        this.getDetailsOnLoad()  
    }

    componentDidUpdate(prevProps) {
        if(prevProps.date !== this.props.date){
            this.getDetailsOnLoad()
            this.updateTab("detalhes")
        }
    }

    updateTab = (tab) => {
        this.setState({
            tab
        }, () => {
            this.showTabDetails(this.state.tab)
        })
    }

    showTabDetails = (tab) => {
        let tabDetail = ''
        if(tab === 'detalhes') {
            tabDetail = (
                <RequestDetails 
                    menu={this.props.header.menu}
                    submenu={this.props.header.submenu}
                    row={this.state.requestDetails}
                    approvedDetails={this.state.approvedDetails}
                    rowDetails={this.props.row}
                    setData={this.setData}
                    sealsRes={this.state.sealsRes}
                    returnSeries={this.state.returnSeries || []}
                />
            )
        }
        else if(tab === 'dadosEntidade') {
            tabDetail = (
                <DadosEntidade 
                    row={this.props.row} 
                    entityDetail={this.state.entityDetail}
                    estatutosRes={this.state.estatutosRes}
                    entityPendingOrders={this.state.entityPendingOrders}
                    entityBalanceSeries={this.state.entityBalanceSeries}
                />
            )
        }
        else if(tab === 'history') {
            tabDetail = (
                <History
                    date={new Date()}
                    history={this.state.history} 
                    header={this.props.header} 
                    row={this.props.row}
                />
            )
        }
        this.setState({
            tabDetail
        })
    }

    getDetailsOnLoad = async () => {
        let id = this.props.row && this.props.row.idRegistoSelo
        if(!id) return

        let link = "Sales/Sales_detailsAndHistory"
        let request = {
            id,
            type: this.props.row.estado
        }
        let res = await services.apiCall.requestApi(link, request, "post")
        let requestDetails
        let history
        let entityPendingOrders
        let entityBalanceSeries
        let approvedDetails
        if(res) {
            console.log("2211 worked ", res)
            requestDetails = {...res.details}
            history = [...res.history]
            entityPendingOrders = [...res.entityPendingOrders]
            entityBalanceSeries = [...res.entityBalanceSeries]
            if(this.props.header.submenu === "approved") {
                approvedDetails = [...res.gestaohistory]
            }
        }
        this.setState({
            requestDetails,
            history,
            entityPendingOrders,
            entityBalanceSeries,
            approvedDetails,
        }, () => {
            this.returnSeries() 
        })        
    }

    returnSeries = async () => {
        let res = []
        if(this.state.requestDetails && this.state.requestDetails.quantidade < 5000000) {
            let request = {}
            request["Quantidade"] = +this.state.requestDetails.quantidade
            let link = "/Sales/ReturnSeries"
            res = await services.apiCall.requestApi(link, request, "post")
        }
       
        this.setState({
            returnSeries: res
        }, () => {
            this.showTabDetails(this.state.tab)
        })
        
    }

    setData = (data) => {
        let newData = {...data}
        this.setState({
            data:{...this.state.data, ...newData}
        })
    }

    handleSubmit = async () => {
        let req = {}
        let res
        let link 

        if(this.state.data.IDEstado === 6) {
            req["Quantidade"] = this.state.requestDetails && this.state.requestDetails.quantidade || null
            req["IDEntidade"] = this.props.row && this.props.row.idEntidade || null
            req["ObservacaoAprov"] = this.state.data && this.state.data.Observacoes || null
            req["IDRegistoSelo"] = this.props.row && this.props.row.idRegistoSelo || null

            if(this.state.requestDetails && this.state.requestDetails.quantidade < 5000000 && this.state.returnSeries.length > 0) {
                req["SeloAtual"] = this.state.data && this.state.data.NumeroSeloFinal || null
                link = "/Sales/CreateNewSealNumber"
            }

            else {
                link = "/Sales/CreateNewSeries"
            } 
        }

        else if(this.state.data.IDEstado === 7 || this.state.data.IDEstado === 12) {
            req["status"] = this.state.data ? this.state.data.IDEstado : null
            req["IDRegistoSelo"] = this.props.row && this.props.row.idRegistoSelo
            req["Observacao"] = this.state.data && this.state.data.Observacoes

            link = "/Sales/SeriesDecision"
        }
        Object.keys(req).forEach(key => {
            if(!req[key]) {
                toast.error("Por favor, preencha todos os campos obrigatórios")
                return
            }
        })
        res = await services.apiCall.requestApi(link, req, "post")
        if(res) {
            toast.success("Sucesso")
            this.props.closePopup()
        }
    }

    render() {
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title bold" style={{fontSize:"large"}}>
                        <b>Detalhe do pedido</b>
                    </span>
                    <div className="buttons">
                        {  this.state.tab !=='history' &&
                            this.props.header &&
                            (this.props.header.submenu === "pending" || this.props.header.submenu === "suspended") &&
                            <Button primary={true} className="remove btn-ivdp-primary cursor-pointer mr-2" onClick={() => this.handleSubmit()}>Gravar</Button>
                        }
                        
                        <Button className="mr-2 k-primary btn-ivdp-secondary btn-theme remove ml-2 text-danger" data-dismiss="modal">Fechar</Button>
                    </div>
                    
                </div>
                <div className="modal-body">

                    {/** tab heading *****************************/}

                <div className="right-tab">
                    <ul className="nav nav-tabs d-flex text-center">
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav right-tab ${this.state.tab=='detalhes'?`active`:""}`}  onClick={() => this.updateTab('detalhes')} data-toggle="tab" href="#Detalhes">Detalhes</a></strong>
                        </li>
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav ${this.state.tab=='dadosEntidade'?`active`:""}`}  onClick={() => this.updateTab('dadosEntidade')} data-toggle="tab" href="#Dados entidade">Dados entidade</a></strong>
                        </li>
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav ${this.state.tab=='history'?`active`:""}`}  onClick={() => this.updateTab('history')} data-toggle="tab" href="#Histórico">Histórico</a></strong>
                        </li>
                    </ul>
                        
                        
                        {/* details as per tab**********************/}
                </div>
                    {this.state.tabDetail}
                </div>
            </div>
        )
    }
}

export default SidePopup